var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payment-first-border" }, [
    _c("div", { staticClass: "payment-first-background" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "payment-first-content-parent" },
      [
        _c(
          "router-link",
          {
            staticClass: "payment-first-shopvidi-logo",
            attrs: { to: { path: "/" } }
          },
          [
            _c("img", {
              attrs: {
                src:
                  "https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png",
                height: "40px",
                width: "160px"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "payment-first-title" }, [
          _vm._v("Grow your business with net 60 terms")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "payment-first-content" }, [
          _vm._v("Order more inventory by increasing your net 60 terms limit!")
        ]),
        _vm._v(" "),
        _vm.flag === "" || _vm.flag === "declined" ? void 0 : _vm._e(),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1)
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment-first-banlance-1" }, [
      _c("img", { attrs: { src: require("@/assets/20240104-163100.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment-first-banlance-2" }, [
      _c("img", { attrs: { src: require("@/assets/20240104-163236.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3db86890", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3db86890","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/credit-payment/payment-first.vue
// module id = null
// module chunks = 